/* Popup plein écran « offre surprise » : déclenchement, étapes, formulaire client Shopify, réouverture. */
(() => {
  const root = document.querySelector('[data-welcome-popup]');
  if (!root) return;
  const pill = document.querySelector('[data-wp-pill]');
  const KEY = 'nacPopup';
  const DAY = 864e5;
  const cfg = root.dataset;
  const now = () => Date.now();
  const read = (store, k) => { try { return JSON.parse(store.getItem(k)); } catch (e) { return null; } };
  const write = (store, k, v) => { try { store.setItem(k, JSON.stringify(v)); } catch (e) { /* stockage bloqué : la popup reste utilisable */ } };
  const state = () => read(localStorage, KEY) || {};
  const save = (patch) => write(localStorage, KEY, Object.assign(state(), patch));
  const session = () => read(sessionStorage, KEY) || {};
  const saveSession = (patch) => write(sessionStorage, KEY, Object.assign(session(), patch));

  /* Mesure sans données personnelles ; les pixels ne reçoivent l'événement que selon le consentement. */
  const track = (name, data) => { try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('nacrelle_popup_' + name, data || {}); } catch (e) { /* ignore */ } };

  const steps = root.querySelectorAll('[data-wp-step]');
  const form = root.querySelector('[data-wp-form]');
  const email = form && form.querySelector('#wp-email');
  const consent = form && form.querySelector('[data-wp-consent]');
  const err = root.querySelector('#wp-error');
  const submitBtn = form && form.querySelector('[data-wp-submit]');
  const tags = form && form.querySelector('[data-wp-tags]');
  let opener = null;

  const show = (n) => {
    steps.forEach((s) => { s.hidden = s.dataset.wpStep !== String(n); });
    root.querySelector('.wp-scroll').scrollTop = 0;
    const target = n === 2 ? email : n === 3 ? root.querySelector('[data-wp-done-title]') : root.querySelector('.wp-btn');
    if (target) setTimeout(() => target.focus({ preventScroll: true }), 30);
  };

  const fillOffer = () => {
    const choice = state().choice || session().choice;
    const btn = choice && root.querySelector(`[data-wp-choice="${choice}"]`);
    const url = (btn && btn.dataset.url) || '/collections/meilleures-ventes';
    const cta = root.querySelector('[data-wp-cta]');
    const code = cfg.code;
    if (!(cfg.live === 'true' && code)) return; /* pas de code utilisable : l'étape 3 reste un simple merci */
    cta.textContent = (btn && btn.dataset.cta) || 'Voir mon offre';
    cta.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(url)}`;
    const ex = root.querySelector('[data-wp-example]');
    if (ex) { ex.textContent = (btn && btn.dataset.example) || ''; ex.hidden = !ex.textContent; }
  };

  const open = (step, auto) => {
    if (!root.hidden) return;
    opener = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('no-scroll');
    if (pill) pill.hidden = true;
    if (step === 3) fillOffer();
    show(step || 1);
    track('view', { auto: !!auto, step: step || 1 });
  };

  const close = (reason) => {
    if (root.hidden) return;
    root.hidden = true;
    document.documentElement.classList.remove('no-scroll');
    const st = state();
    if (!st.done) save({ until: now() + Number(cfg.closeDays || 14) * DAY });
    if (pill) pill.hidden = false;
    track('close', { reason });
    if (opener && opener.focus) opener.focus();
  };

  root.querySelectorAll('[data-wp-close]').forEach((b) => b.addEventListener('click', () => close(b.hasAttribute('data-wp-skip') ? 'non_merci' : 'x')));
  document.addEventListener('keydown', (e) => {
    if (root.hidden) return;
    if (e.key === 'Escape') { close('escape'); return; }
    if (e.key !== 'Tab') return;
    /* Focus maintenu dans la popup. */
    const f = [...root.querySelectorAll('button, a[href], input')].filter((el) => el.offsetParent !== null && !el.disabled);
    if (!f.length) return;
    const first = f[0]; const last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  root.querySelectorAll('[data-wp-choice]').forEach((b) => b.addEventListener('click', () => {
    const choice = b.dataset.wpChoice;
    saveSession({ choice });
    save({ choice });
    if (tags) tags.value = `newsletter, popup-surprise, choix-${choice}`;
    track('choice', { choice });
    show(2);
  }));
  const back = root.querySelector('[data-wp-back]');
  if (back) back.addEventListener('click', () => show(1));

  const fail = (msg, field) => {
    err.textContent = msg;
    err.hidden = false;
    if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
  };
  if (email) email.addEventListener('input', () => { email.removeAttribute('aria-invalid'); err.hidden = true; });
  if (consent) consent.addEventListener('change', () => { err.hidden = true; });

  /* Phase de capture : notre contrôle passe avant le script anti-robot de Shopify, qui envoie le formulaire lui-même. */
  if (form) document.addEventListener('submit', (e) => {
    if (e.target !== form) return;
    const stop = () => { e.preventDefault(); e.stopImmediatePropagation(); };
    const v = email.value.trim();
    email.value = v;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { stop(); fail('Adresse e-mail incorrecte. Exemple : prenom.nom@exemple.fr', email); return; }
    if (!consent.checked) { stop(); fail('Pour recevoir votre offre par e-mail, cochez la case d’accord.', consent); return; }
    if (form.dataset.sending) { stop(); return; }
    form.dataset.sending = '1';
    submitBtn.disabled = true;
    submitBtn.textContent = 'Envoi en cours…';
    saveSession({ pending: true });
    /* Envoi classique (formulaire client Shopify) : la page revient avec ?customer_posted=true. */
  }, true);

  /* Retour du formulaire : succès ou erreur Shopify. */
  const posted = root.querySelector('[data-wp-posted]');
  const serverErr = root.querySelector('[data-wp-server-error]');
  const pending = session().pending;
  if (pending && (posted || serverErr)) {
    saveSession({ pending: false, shown: true });
    if (posted) {
      save({ done: true, until: now() + Number(cfg.successDays || 30) * DAY });
      track('email_submit_success', { choice: state().choice || '' });
      open(3, false);
      track('discount_revealed', { choice: state().choice || '' });
    } else {
      open(2, false);
      fail('Inscription impossible pour le moment : ' + serverErr.textContent.trim() + ' Vérifiez l’adresse et réessayez.', email);
    }
    if (history.replaceState) { const u = new URL(location.href); u.searchParams.delete('customer_posted'); u.hash = ''; history.replaceState(null, '', u); }
  }

  const copy = root.querySelector('[data-wp-copy]');
  if (copy) copy.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(cfg.code); } catch (e) {
      const r = document.createRange(); r.selectNodeContents(root.querySelector('[data-wp-code]'));
      const s = getSelection(); s.removeAllRanges(); s.addRange(r); try { document.execCommand('copy'); } catch (x) { /* ignore */ }
    }
    copy.textContent = 'Code copié ✓';
    setTimeout(() => { copy.textContent = 'Copier le code'; }, 2500);
  });
  const cta = root.querySelector('[data-wp-cta]');
  if (cta) cta.addEventListener('click', () => track('offer_cta_click', { choice: state().choice || '' }));

  if (pill) pill.addEventListener('click', () => open(state().done ? 3 : 1, false));

  /* Déclenchement automatique : 15 s sur la 1re page, 5 s ensuite, 1 fois par session, pauses 14 / 30 jours. */
  const params = new URLSearchParams(location.search);
  const st = state();
  const ss = session();
  const paused = st.until && st.until > now();
  if (st.done || paused || ss.shown) { if (pill && (st.done || paused || ss.shown) && root.hidden) pill.hidden = false; }
  /* Contrôle qualité : ?popup=1|2|3 (et &choice=…) ouvre l'étape voulue sans rien enregistrer côté Shopify. */
  const forceStep = Math.min(3, Math.max(1, Number(params.get('popup')) || 1));
  const force = ['1', '2', '3'].includes(params.get('popup'));
  /* Éditeur de thème : ouverture seulement quand la section est sélectionnée, jamais par-dessus les autres pages. */
  if (cfg.editor === 'true') {
    document.addEventListener('shopify:section:select', (e) => { if (root.closest('.shopify-section') && e.target === root.closest('.shopify-section')) open(1, false); });
    document.addEventListener('shopify:section:deselect', (e) => { if (e.target === root.closest('.shopify-section')) close('editor'); });
    return;
  }
  if (force && params.get('choice')) saveSession({ choice: params.get('choice') });
  const blocked = () => document.documentElement.classList.contains('no-scroll') || /\/(cart|checkout|checkouts)(\/|$)/.test(location.pathname);
  /* Pas d'ouverture pendant une interaction en cours (défilement, toucher, saisie) : on attend 4 s de calme. */
  let lastAction = 0;
  ['pointerdown', 'keydown', 'scroll', 'touchstart', 'wheel'].forEach((ev) => addEventListener(ev, () => { lastAction = now(); }, { passive: true, capture: true }));
  const busy = () => now() - lastAction < 4000 || /^(INPUT|SELECT|TEXTAREA)$/.test((document.activeElement || {}).tagName || '');
  const auto = () => {
    if (!root.hidden || session().shown) return;
    if (blocked() || busy()) { setTimeout(auto, 1500); return; }
    saveSession({ shown: true });
    open(1, true);
  };
  if (force && !pending) { setTimeout(() => open(forceStep, false), 300); return; }
  /* Offre non active : jamais d'ouverture automatique (aucun code non utilisable n'est promis). */
  if (pending || st.done || paused || ss.shown || blocked() || cfg.live !== 'true') return;
  /* Fond chargé pendant l'attente, pour qu'il soit prêt à l'ouverture. */
  setTimeout(() => { const img = root.querySelector('.wp-bg img'); if (img) img.loading = 'eager'; }, 3000);
  const pages = (ss.pages || 0) + 1;
  /* Visiteur arrivé par une pub Meta (utm_source ou fbclid) : délai plus long sur chaque page de la session, pour ne pas couper la comparaison. 0 = désactivé. */
  const metaDelay = Number(cfg.metaDelay || 0);
  const fromMeta = ss.meta || /^(meta|facebook|fb|instagram|ig)$/i.test(params.get('utm_source') || '') || params.has('fbclid');
  saveSession({ pages, meta: fromMeta });
  let delay = pages === 1 ? Number(cfg.firstDelay || 15) : Number(cfg.nextDelay || 5);
  if (fromMeta && metaDelay > 0) delay = Math.max(delay, metaDelay);
  setTimeout(auto, delay * 1000);
})();
